<template>
  <div :class="['drag-view', action ? 'action' : '']">
    <drag
      ref="drags"
      v-for="(item, index) of list"
      :key="item.id"
      :item="item"
      :safe="safe"
      @on-touchstart="onDragTouchStart(item)"
    >
      <div :class="['view', item.scrollHidden ? 'action-item' : '']">
        <img
          :class="['clearable', item.layout]"
          v-if="item.clearable"
          src="https://img.chinabeego.com/uploadfile/2022/10/31/16671974220605115531595201229.png"
          alt=""
          @click="onClearableClick(item)"
        />
        <img class="image" :src="item.src" alt="" @click="onItemClick(item)" />
      </div>
    </drag>
    <div class="fixed-view" ref="fixed-view">
      <div class="item page-scroll-to-top" @click.stop="onToTopClick">
        <img class="item" v-show="top.show" :src="top.src" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Drag from './drag';
import { navigateTo } from '@/views/activities/utils/navigateTo';
import {
  INIT_ZINDEX,
  MAX_ZINDEX,
  SPACE,
  StatusEnum,
  useSafeArea,
  useWidths,
  useDebounce
} from './utils';

export default {
  components: { Drag },
  props: {
    home: Object,
    floor: Object
  },
  data() {
    return {
      safe: useSafeArea(),
      widths: useWidths(),
      list: [],
      zIndex: INIT_ZINDEX,
      action: false,
      top: {
        show: false,
        src:
          'https://img.chinabeego.com/uploadfile/2022/11/1/16672953587117800608425953981.png'
      }
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.$root.$el.addEventListener('scroll', this.onRootScroll);
    this.$root.$el.addEventListener('touchend', this.onRootTouchEnd);
  },
  beforeDestroy() {
    this.$root.$el.removeEventListener('scroll', this.onRootScroll);
    this.$root.$el.removeEventListener('touchend', this.onRootTouchEnd);
  },
  methods: {
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    async init() {
      if (this.unwatch) this.unwatch();
      if (!this.$refs['fixed-view']) {
        await this.$nextTick();
      }
      this.normalizeFloor();
      this.unwatch = this.$watch('floor', this.init);
    },
    normalizeFloor() {
      const { widths, floor, safe } = this;
      const { open } = StatusEnum;
      const node = this.$refs['fixed-view'].getBoundingClientRect();
      const list = [];
      const toArray = (s, v) => (s === open && Array.isArray(v) ? v : []);
      [
        toArray(floor.rightStatus, floor.itemsRight),
        toArray(floor.leftStatus, floor.itemsLeft)
      ].forEach((children, index) => {
        let isRight = index === 0;
        let distance = safe.bottom + (isRight ? node.height : 0);
        return children.forEach((item) => {
          const src = item.imageImage && item.imageImage.imageUrl;
          const [width, height] = widths[item.imageStyle];
          const left = isRight ? safe.width - width - safe.margin : safe.margin;
          const top = safe.height - height - distance;
          distance += height + SPACE;
          list.push({
            id: item.id,
            width,
            height,
            top,
            left,
            src,
            show: true,
            zIndex: INIT_ZINDEX,
            layout: isRight ? 'right' : 'left',
            fixed: item.locationFixedFlag === 0, // 是否固定，不可拖拽
            dragAny: item.locationFixedFlag === 1, // 是否可拖拽至任意位置
            dragAdsorptive: item.locationFixedFlag === 2, // 是否拖拽后吸附边缘
            scrollHidden: item.hiddenConfigFlag === 1, // 是否页面滚动时隐藏
            clearable: item.windowCloseFlag === 1, // 是否显示关闭按钮
            pageLinkType: item.pageLinkType,
            pageLinkValue: item.pageLinkValue
          });
        });
      });
      this.list = list;
    },
    async updateLayout() {
      await this.$nextTick();
      const { safe, list } = this;
      const node = this.$refs['fixed-view'].getBoundingClientRect();
      const drags = this.$refs.drags || [];
      let distance = safe.bottom + node.height;
      drags.forEach((drag, i) => {
        const item = list[i];
        if (item.layout !== 'right') return;
        if (drag.neverMoved()) {
          item.top = safe.height - item.height - distance;
        }
        distance += item.height + SPACE;
      });
    },
    onItemClick(item) {
      if (item.pageLinkType === 15 /*视频号*/) {
        this.$dialog.confirm({
          message:
            '请到微信小程序中操作！微信搜索【8号仓奥莱】，选择并进入小程序。',
          showCancelButton: false
        });
        return;
      }
      navigateTo(this, {
        pageLinkType: item.pageLinkType,
        pageLinkValue: item.pageLinkValue
      });
    },
    onClearableClick(item) {
      item.show = false;
    },
    onToTopClick() {
      this.$root.$el.scrollTop = 0;
      this.useOff();
    },
    onRootScroll() {
      const top = this.$root.$el.scrollTop;
      const show = top > this.safe.height;
      if (this.top.show !== show) {
        this.top.show = show;
      }
      // 点击滚动到顶部时 此时刚好执行this.doAction()
      // this.action设为false 但是没更新视图
      // 滚动到顶部又会触发当前函数，如果不使用this.off控制
      // this.action 又会被设为true 导致无法触发动画
      if (this.off) return;
      if (!this.action) {
        this.action = true;
      }
      this.debounce();
    },
    onRootTouchEnd() {
      this.touchend = true;
      this.doAction();
    },
    debounce: useDebounce(function() {
      this.scolled = true;
      this.doAction();
    }, 300),
    doAction() {
      if (this.action && this.scolled && this.touchend) {
        this.scolled = false;
        this.touchend = false;
        this.action = false;
        this.useOff();
      }
    },
    useOff() {
      this.off = true;
      setTimeout(() => {
        this.off = false;
      }, 250);
    },
    onDragTouchStart(item) {
      // 保持当前拖拽元素的层级是最高的
      item.zIndex = ++this.zIndex;
      // 当层级超过最大值时需要重置一下，不然层级会越来越高
      if (this.zIndex > MAX_ZINDEX) {
        this.zIndex = INIT_ZINDEX;
        this.list
          .slice()
          .sort((a, b) => a.zIndex - b.zIndex)
          .forEach((item) => {
            if (item.zIndex > INIT_ZINDEX) {
              item.zIndex = ++this.zIndex;
            }
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.drag-view .view {
  width: 100%;
  height: 100%;
  transition: transform 0.2s;
  transform: scale(1, 1);
}
.action .action-item {
  transform: scale(0, 0);
}
.drag-view .image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.drag-view .clearable {
  position: absolute;
  top: -12px;
  z-index: 1;
  width: 40px;
  height: 40px;
}
.drag-view .clearable.left {
  left: -12px;
}
.drag-view .clearable.right {
  right: -12px;
}
.fixed-view {
  position: fixed;
  right: 18px;
  bottom: 44px;
  z-index: 31;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}
.fixed-view .item {
  display: block;
  width: 108px;
  height: 108px;
  pointer-events: all;
}
.fixed-view .page-scroll-to-top {
  pointer-events: none;
}
</style>
